import React  from 'react'

import {FieldTListGroupHeader2Props} from "../../../render/list/group-2"

export default function FieldProto_TListGroupHeader2(props: FieldTListGroupHeader2Props) {
    return <div className="ui5-txt-default ui5-txt-red">{props.field.type}.tlistGroupHeader2</div>
}